import React from 'react';
import PropTypes from 'prop-types';

import { Th } from './css';

const style = {
  backgroundColor: '#8c68a6',
  color: '#fff',
  fontSize: '20px',
  padding: '10px'
};

const TableHeader = ({ heading, keys, data, onClick, sortIndex, sortIcon }) => {
  const length = keys.length + 1;
  const width = 100 / length;

  return (
    <thead>
      <tr>
        <td colSpan={length} style={style}>
          {heading}
        </td>
      </tr>
      <tr>
        <Th width={width}>#</Th>
        {keys.map((k, index) => {
          const key = `header${index}`;
          const icon = sortIndex === k ? sortIcon : '';
          const attributes = { key, width };
          if (onClick) attributes.onClick = () => onClick(k);

          return <Th {...attributes}>{`${data[k]} ${icon}`}</Th>;
        })}
      </tr>
    </thead>
  );
};

TableHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.objectOf(PropTypes.string).isRequired,
  onClick: PropTypes.func,
  sortIndex: PropTypes.string,
  sortIcon: PropTypes.string
};

TableHeader.defaultProps = {
  onClick: null,
  sortIndex: null,
  sortIcon: null
};

export default TableHeader;
